import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

/**
 * Free-form tag input. Press Enter or comma to add.
 * value: array of strings
 * onChange: (string[]) => void
 */
export default function TagInput({
  value = [],
  onChange,
  placeholder = "Type and press Enter…",
  testIdPrefix = "tag-input",
}) {
  const [draft, setDraft] = useState("");

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (value.includes(v)) {
      setDraft("");
      return;
    }
    onChange([...value, v]);
    setDraft("");
  };

  const remove = (v) => onChange(value.filter((x) => x !== v));

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add();
    } else if (e.key === "Backspace" && !draft && value.length) {
      remove(value[value.length - 1]);
    }
  };

  return (
    <div className="flex flex-wrap gap-1.5 items-center border border-input rounded-md px-2 py-2 bg-transparent min-h-10">
      {value.map((v) => (
        <Badge
          key={v}
          variant="secondary"
          className="rounded-none gap-1 pr-1"
          data-testid={`${testIdPrefix}-tag-${v}`}
        >
          {v}
          <button
            type="button"
            onClick={() => remove(v)}
            className="inline-flex items-center justify-center rounded-sm hover:bg-muted-foreground/20 p-0.5"
            aria-label={`Remove ${v}`}
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
      <Input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={add}
        placeholder={value.length === 0 ? placeholder : ""}
        className="flex-1 min-w-[8rem] border-0 px-1 h-7 focus-visible:ring-0"
        data-testid={`${testIdPrefix}-input`}
      />
    </div>
  );
}
